var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { DunningStage } from '../identity/types.js';
import { DunningRunItemStatus } from '../enums/dunning-run-item-status.enum.js';
import { DunningRunStatus } from '../enums/dunning-run-status.enum.js';
/**
 * One `DunningRunItem` row inside the status response. Mirrors the domain
 * entity but adds invoice + patient identity so the frontend can render
 * the per-row table without a second query.
 */
export class DunningRunItemStatusDto {
    invoiceId;
    invoiceNumber;
    patientFirstName;
    patientLastName;
    dunningStage;
    status;
    /** Set when status === SUCCESS. */
    dunningLetterId;
    /** Set when status === SKIPPED. */
    skipReason;
    /** Set when status === FAILED. */
    errorMessage;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunItemStatusDto.prototype, "invoiceId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunItemStatusDto.prototype, "invoiceNumber", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunItemStatusDto.prototype, "patientFirstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunItemStatusDto.prototype, "patientLastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunItemStatusDto.prototype, "dunningStage", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunItemStatusDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunItemStatusDto.prototype, "dunningLetterId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunItemStatusDto.prototype, "skipReason", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunItemStatusDto.prototype, "errorMessage", void 0);
/**
 * Response of `GET /v1/dunningRun/:id` — drives the Running and Completed
 * sidebar views. Polled at ~1.5s `refetchInterval` while `status` is
 * IN_PROGRESS; polling stops on terminal state.
 */
export class DunningRunStatusResponseDto {
    id;
    officeLocationId;
    status;
    /** ISO timestamp; null while still PENDING. */
    startedAt;
    /** ISO timestamp; null until COMPLETED / CANCELED / FAILED. */
    completedAt;
    /**
     * Cutoff date (Stichtag) the run was assembled with — the payment-trust
     * horizon recorded at command time. ISO timestamp; null = no cutoff.
     */
    dueUpTo;
    totalCount;
    successCount;
    skippedCount;
    failedCount;
    pendingCount;
    items;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunStatusResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunStatusResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningRunStatusResponseDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunStatusResponseDto.prototype, "startedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunStatusResponseDto.prototype, "completedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningRunStatusResponseDto.prototype, "dueUpTo", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunStatusResponseDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunStatusResponseDto.prototype, "successCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunStatusResponseDto.prototype, "skippedCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunStatusResponseDto.prototype, "failedCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningRunStatusResponseDto.prototype, "pendingCount", void 0);
__decorate([
    Expose(),
    Type(() => DunningRunItemStatusDto),
    __metadata("design:type", Array)
], DunningRunStatusResponseDto.prototype, "items", void 0);
//# sourceMappingURL=dunning-run-status.response.dto.js.map